import { CSSProperties, ReactNode } from 'react';
import { ClusterStatus } from '@nkr/enums/index';
import { OverlayTrigger, Row, Tooltip, Well } from 'react-bootstrap';

const LegendItem = ({ text, style, children }: { text: string, style: CSSProperties, children: ReactNode }) => (
    <OverlayTrigger placement='top' overlay={<Tooltip id={'legend-' + text.replace(/\W+/g, '-')}>{text}</Tooltip>}>
        <div style={style}>{children}</div>
    </OverlayTrigger>
);

const Legend = ({ clusterStatusId, small }: { clusterStatusId: number, small: boolean }) => {
    return (
        <>
            <Well bsSize='small' style={{ margin: 0 }}>
                <Row>
                    {clusterStatusId != ClusterStatus.Stalled && (
                        <div style={{ display: 'flex', fontSize: small ? 10 : 12 }}>

                            {clusterStatusId == ClusterStatus.Offers && (
                                <LegendItem
                                    text='Chain Starter with < one-week donation range.'
                                    style={{ display: 'flex', alignItems: 'center', marginLeft: 20, marginRight: 30 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: '#adadeb',
                                            border: '1px solid #ddd',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>CS &lt; 5 business days</div>
                                </LegendItem>
                            )}

                            <LegendItem
                                text='Voucher donor pending offer'
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginLeft: clusterStatusId !== ClusterStatus.Offers ? 20 : 0,
                                    marginRight: 30
                                }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: '#C83333',
                                        border: '1px solid #ddd',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>VDPO</div>
                            </LegendItem>

                            <LegendItem
                                text='Voucher donor pending donation'
                                style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: '#ddd',
                                        border: '1px solid #ddd',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>VDPD</div>
                            </LegendItem>

                            <LegendItem
                                text='Voucher recipient TXP before voucher donor donation'
                                style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: '#FF954D',
                                        border: '1px solid #FF954D',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>VR TXP &lt; VDD</div>
                            </LegendItem>

                            <LegendItem
                                text='Outside donation range'
                                style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        border: '2px solid rgb(255, 0, 0)',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>ODR</div>
                            </LegendItem>

                            <LegendItem
                                text='Surgery date contention'
                                style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: 'yellow',
                                        border: '1px solid #ddd',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>SDC</div>
                            </LegendItem>

                            <LegendItem
                                text='Red Eye'
                                style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: '#EF9A9A',
                                        border: '1px solid #ddd',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>RE</div>
                            </LegendItem>

                            <LegendItem
                                text='Surgery date contention and red eye'
                                style={{ display: 'flex', alignItems: 'center', marginRight: 50 }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: '#4949F5',
                                        border: '1px solid #ddd',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>SDC + RE</div>
                            </LegendItem>
                        </div>
                    )}

                    {clusterStatusId == ClusterStatus.Stalled && (
                        <div style={{ display: 'flex', fontSize: small ? 10 : 12 }}>

                            <LegendItem
                                text='Any AB donor, any A donor over the age of 55, or any B donor over the age of 65.'
                                style={{ display: 'flex', alignItems: 'center', marginLeft: 20, marginRight: 30 }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: 'yellow',
                                        border: '1px solid #ddd',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>Any AB donor, any A donor over the age of 55, or any B donor over the age of 65.</div>
                            </LegendItem>

                            <LegendItem
                                text='Donor is within 28 calendar days of the last day of their donation range'
                                style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: 'green',
                                        border: '1px solid #ddd',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>Donor is within 28 calendar days of the last day of their donation range</div>
                            </LegendItem>

                            <LegendItem
                                text='Chain Starter with < one-week donation range.'
                                style={{ display: 'flex', alignItems: 'center', marginRight: 50 }}
                            >
                                <div
                                    style={{
                                        height: 20,
                                        width: 20,
                                        backgroundColor: '#adadeb',
                                        border: '1px solid #ddd',
                                        marginRight: 5,
                                        borderRadius: 4
                                    }}
                                />
                                <div>CS &lt; 5 business days</div>
                            </LegendItem>
                        </div>
                    )}
                </Row>
            </Well>
        </>
    );
}

export default Legend;